
import { useState, forwardRef } from 'react';
import classes from "./CustomInput.module.css";
import { useTranslation } from 'react-i18next';

const Textarea = forwardRef(({ 
  className = '', 
  maxNumberOfChar,
  value: controlledValue,
  onChange: controlledOnChange,
  ...props 
}, ref) => {
  const [internalValue, setInternalValue] = useState('');
  const {t} = useTranslation("general");
  
  const isControlled = controlledValue !== undefined;
  const value = isControlled ? controlledValue : internalValue;
  
  const handleChange = (e) => {
    const newValue = e.target.value;
    
    if (maxNumberOfChar && newValue.length > maxNumberOfChar) {
      return;
    }
    
    if (!isControlled) {
      setInternalValue(newValue);
    }
    controlledOnChange?.(e);
  };
  
  const showCounter = maxNumberOfChar !== undefined;
  const remaining = maxNumberOfChar ? maxNumberOfChar - value.length : 0;
  const isNearLimit = remaining <= 20;
  const isAtLimit = remaining === 0;
  
  return (
    <div className="grid w-full gap-2">
      <textarea
        className={classes.textInput}
        ref={ref}
        value={value}
        onChange={handleChange}
        {...props}
      />
      {showCounter && (
        <div className="neutral-value o-row o-row--horizontal-align_end u-margin--top_200">
          <span className={`t-text-mini t-bold_bold ${isNearLimit&& "negative-value"}`}>
            {value.length} / {maxNumberOfChar} {t("character")}
          </span>
        </div>
      )}
    </div>
  );
});

Textarea.displayName = 'Textarea';

export default Textarea;
